export function updateWeglotDropdownUrls(nextPageHtml: string): void {
	const activeItems = getListItems(document);
	if (!activeItems) return;

	const parser = new DOMParser();
	let dom = parser.parseFromString(nextPageHtml, 'text/html');
	const newPageItems = getListItems(dom);
	if (!newPageItems) return;

	for (var i = 0; i < newPageItems.length; i++) {
		matchListItemUrls(activeItems[i], newPageItems[i]);
	}
}

function matchListItemUrls(activeItem: HTMLUListElement, newPageItem: HTMLUListElement): void {
	const correctedHref = newPageItem.querySelector('a')?.href;
	if (correctedHref) activeItem.querySelector('a')?.setAttribute('href', correctedHref);
}

function getListItems(dom: Document): NodeListOf<HTMLUListElement> | null {
	const weglotDropdown = dom.querySelector('.weglot-dropdown');
	const listItems = weglotDropdown?.querySelectorAll('li[data-code-language]') as NodeListOf<HTMLUListElement>;
	return listItems;
}
